import { render } from "./TaskHome.vue?vue&type=template&id=64940d1b&scoped=true"
import script from "./TaskHome.vue?vue&type=script&lang=js"
export * from "./TaskHome.vue?vue&type=script&lang=js"

import "./TaskHome.vue?vue&type=style&index=0&id=64940d1b&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64940d1b"]])

export default __exports__